module.exports = __webpack_public_path__ + "nc_static/media/sw-installing.de79e3d3.svg";